import { fireErrorAnalytics } from '@jira/platform__error-reporting/src/fireErrorAnalytics.tsx';
import { routeAnalyticsAttributes } from '@atlassian/jira-platform-route-analytics/src/main.tsx';
import { unreportedStatsigInitialisationError } from '@atlassian/jira-feature-gates-unsafe-init/src/unreported-statsig-initialisation-error.tsx';

/** Statsig initialisation errors may occur during early scripts, where analytics clients are not available.
 * Therefore, such an initialisation error is stored in a global variable. Later, when the analytics client
 * finally becomes available, this function can be called to report the error.
 */
export const reportUnreportedStatsigInitialisationError = () => {
	if (unreportedStatsigInitialisationError) {
		fireErrorAnalytics({
			error: unreportedStatsigInitialisationError,
			meta: {
				id: 'statsig-init-failure',
				teamName: 'uip-app-framework',
			},
			attributes: routeAnalyticsAttributes,
			skipSentry: false,
		});
	}
};
